//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import * as productFeedHealthApi from '@apis/product-feed-health/productFeedHealthApi';

import { GetNgApiAdapterType, createNgApiAdapterService } from 'app/angular-apis/createNgApiAdapter';

const productFeedHealthApiService = createNgApiAdapterService(productFeedHealthApi);
export type ProductFeedHealthApiService = GetNgApiAdapterType<typeof productFeedHealthApiService>;

angular.module('curalate').service('ProductFeedHealthApiService', productFeedHealthApiService);
